export default __webpack_public_path__ + "static/media/postitheader.d42dd498.JPG";